<script lang="ts">
  import('App/PurchasereceiptsBackup').then((m) => {
    let module = m.default;

    new module({
      target: document.getElementById('purchase-recipts-backup'),
      layout: 'auto',

      props: {
        schema: {
          visibility: {
            readOnly: true,
          },
        },
      },
    });
  });
</script>

<div id="purchase-recipts-backup" />
